import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { useAppSelector } from '@/hooks/redux-hooks';
import routeArray from '@/components/NavBar/routeArray';
import isAccessGranted from '@/utils/isAccessGranted';
import { useNavigate } from 'react-router-dom';
import AccessDenied from '@/components/ErrorPage/examples/AccessDenied';

const Index = () => {
  const isExportMode = process.env.MARKET === 'export';

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [accessDenied, setAccessDenied] = useState(false);

  const { user } = useAppSelector((state) => state.currentUserReducer);

  useEffect(() => {
    const availableRoute = routeArray.find(({roles, noExport}) => {
      const availableAtTheExportStand = !(isExportMode && noExport);

      return isAccessGranted(roles, user) && availableAtTheExportStand;
    });

    if (availableRoute) {
      navigate(availableRoute.route);
      return;
    }

    setAccessDenied(true);

    return () => {
      setAccessDenied(false);
    }
  }, [user]);

  if (accessDenied) {
    return <AccessDenied />;
  }

  return (
    <div className={styles.index}>
      {t('pages.admin.startText')}
    </div>
  );
};

export default Index;
